import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import { InputComponent } from 'components/common/Input';
import { INPUT_TYPE } from 'components/common/Input/types';
import ErrorContainer from 'components/ErrorContainer';
import { Form, Formik } from 'formik';
// import TwitterOutlined from '@ant-design/icons/lib/icons/TwitterOutlined';
// import GithubOutlined from '@ant-design/icons/lib/icons/GithubOutlined';
// import FacebookOutlined from '@ant-design/icons/lib/icons/FacebookOutlined';
// import GoogleOutlined from '@ant-design/icons/lib/icons/GoogleOutlined';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { RootState } from 'redux/types';
import ROUTES from 'routes/routeConstants';
import { ActionButtonContainer } from 'routes/SignIn/components/styled';
import AuthService from 'services/api/auth.service';
import IntlMessages from 'utils/IntlMessages';
import * as Yup from 'yup';

const ResetPasswordSchema = Yup.object({
  email: Yup.string().email('Invalid Email').required('Required'),
});

const ResetPasswordFormContent: React.FC = () => {
  const { accessToken } = useSelector<RootState, RootState['auth']>(({ auth }) => auth);
  const [isResetSuccess, setResetState] = useState(false);
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (accessToken) {
      history.push('/');
    }
  });

  const onFinish = async (values: { email: string }) => {
    setLoading(true);

    try {
      await AuthService.resetPassword({ email: values.email });
      setResetState(true);
    } catch (err) {
      setError('Can not find user with provided email');
      console.log('er', err);
    }

    setLoading(false);
  };

  return (
    <>
      <div className='gx-app-login-content'>
        {isResetSuccess ? (
          <div>
            <IntlMessages id='resetPasswordSuccess.title' />
            <ActionButtonContainer marginTop='10px'>
              <Link to={ROUTES.SIGN_IN}>
                <IntlMessages id='app.userAuth.goBack' />
              </Link>
            </ActionButtonContainer>
          </div>
        ) : (
          <>
            <Formik
              initialValues={{ email: '' }}
              name='basic'
              onSubmit={onFinish}
              validationSchema={ResetPasswordSchema}
              validateOnBlur>
              <Form className='gx-signin-form gx-form-row0'>
                <InputComponent
                  type={INPUT_TYPE.EMAIL}
                  name={INPUT_TYPE.EMAIL}
                  label='Email'
                  placeholder='Email'
                  style={{ width: '100%' }}
                />
                {error && (
                  <ErrorContainer>
                    <>{error}</>
                  </ErrorContainer>
                )}
                <ActionButtonContainer marginTop='0'>
                  <ButtonWithSpinner width='130px' isLoading={isLoading} className='gx-mb-0' htmlType='submit'>
                    <IntlMessages id='app.userAuth.resetPassword' />
                  </ButtonWithSpinner>
                  <Link to={ROUTES.SIGN_IN}>
                    <IntlMessages id='app.userAuth.goBack' />
                  </Link>
                </ActionButtonContainer>
                {/* <div className='gx-flex-row gx-justify-content-between'>
                  <span>or connect with</span>
                  <ul className='gx-social-link'>
                    <li>
                      <GoogleOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <FacebookOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <GithubOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <TwitterOutlined onClick={() => {}} />
                    </li>
                  </ul>
                </div>
                <span className='gx-text-light gx-fs-sm'>
                  {' '}
                  demo user email: &apos;demo@example.com&apos; and password: &apos;demo#123&apos;
                </span> */}
              </Form>
            </Formik>
          </>
        )}
      </div>
    </>
  );
};

export default ResetPasswordFormContent;
